import { AbstractRepository } from "../repository";

export class NotificationLog {
  constructor(
    public readonly id: string,
    public readonly type: string,
    public readonly status: "pending" | "sent" | "success" | "failed",
    public readonly receiverName: string,
    public readonly title: string,
    public readonly preview: string,
    public readonly reason: string | null,
    public readonly created_at: Date,
    public readonly updated_at: Date,
  ) {}

  static fromJson(json: any): NotificationLog {
    return new NotificationLog(
      json["id"],
      json["type"],
      json["status"],
      json["receiver_name"],
      json["title"],
      json["preview"],
      json["reason"],
      new Date(json["created_at"]),
      new Date(json["updated_at"]),
    );
  }
}

export default class NotificationLogsRepository extends AbstractRepository {
  public async browse() {
    const json = await this.request<{ items: object[] }>("GET", `notification-logs`);
    return json.items.map((item) => NotificationLog.fromJson(item));
  }

  public async delete(notificationLogId: string) {
    await this.request("DELETE", `notification-logs/${notificationLogId}`);
  }
}
